import React, { } from 'react';
import '../App.css';

function Dialogimg(props) {

  const imgnotfound = "data:image/png;base64,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";
  const divDialog = document.getElementById("Dialogimg");
  let arrImg = [];
  if (props.i1 != null) {
    arrImg.push(props.i1)
  }
  if (props.i2 != null) {
    arrImg.push(props.i2)
  }
  const closeDialog = () => {
    divDialog.close();
  }

  const takeImg = (e) => {
    let arrImgSelected = [];
    let allImg = divDialog.querySelectorAll('img');
    for (let index = 0; index < allImg.length; index++) {
      if (allImg[index].style.border === "4px solid blue") {
        arrImgSelected.push(allImg[index]);
      }

    }
    if (arrImgSelected.length > 1) {
      alert('puoi modificare una sola immagine alla volta')
    } else {
      const fl = new FileReader();
      let files = e.target.files;
      let file = files[0];
      if (file) {

        fl.addEventListener("load", function () {
          arrImgSelected[0].src = this.result;
        })
      }
      fl.readAsDataURL(file)
    }



  }

  const deleteImg = () => {
    let allImg = divDialog.querySelectorAll('img');
    for (var i = 0; i < allImg.length; i++) {
      if (allImg[i].style.border === "4px solid blue") {
        allImg[i].src = imgnotfound;
      }
    }
  }


  const openFupl = () => {
    var fupl = document.getElementById("fupl");
    fupl.click();
  }

  const selectImg = (e) => {
    let img = e.target;
    if (img.style.border === 'none') {
      img.style.border = "3px solid red";
    } else {
      img.style.border = "none";
    }


  }
  return (
    <dialog id="Dialogimg">
      <div id="div-container">
        {
          
          arrImg.map((item, index) => {
            if (!index % 2) {
              return (
                <div className="div-img">
                  <img alt='' src={item} onClick={(e) => selectImg(e)}></img>
                  <img alt='' src={arrImg[index+1]} onClick={(e) => selectImg(e)}></img>
                </div>
              )
            } 
            
            return <div/>
            

          })
        }
      </div>
      <hr></hr>
      <div id="div-bottoni">
        <button className="btn-black" onClick={closeDialog}>CLOSE</button>
        <button className="btn-black" onClick={openFupl}>EDIT</button>
        <button className="btn-black" onClick={deleteImg}>DELETE</button>
        <input type="file" hidden="hidden" id="fupl" onChange={(e) => takeImg(e)}></input>
      </div>

    </dialog>
  );
}

export default Dialogimg;
